import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, createBemBlockBuilder, ShowMore } from '@ebsco-ui/ebsco-ui';

import { ShowMoreButton } from '@app/components';
import { courseReservesMessages } from '@app/translations';

import { BrowseByComponent } from './constants';

const departmentsListLimit = 10;

const cnBem = createBemBlockBuilder(['browseBy']);

export const BrowseByDepartments: FC<BrowseByComponent> = ({
  records,
  getSearchPath,
}) => {
  const { browseByDepartment } = courseReservesMessages;

  return (
    <section className={cnBem('__departments')}>
      <h2 className={cnBem('__title')}>
        <FormattedMessage {...browseByDepartment} />
      </h2>
      <ShowMore limit={departmentsListLimit}>
        <ul data-auto="departments-list">
          <ShowMore.Items>
            {records.map(department => (
              <li
                className={cnBem('__departmentsItemButton')}
                key={department.id}
              >
                <Link to={getSearchPath(department.name)}>
                  <Button styleType="pill" tabIndex={-1}>
                    {department.name}
                  </Button>
                </Link>
              </li>
            ))}
          </ShowMore.Items>
          <li className={cnBem('__departmentsItemButton')}>
            <ShowMoreButton
              showMoreLimit={departmentsListLimit}
              dataLength={records.length}
            />
          </li>
        </ul>
      </ShowMore>
    </section>
  );
};
